import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class ActionCallVariableDefinition extends TypedDefinition {
  override extends = ['Action']
  override properties: TypedSchema[] = [
    {
      name: 'props',
      properties: [
        {
          name: 'variableId',
          type: 'Schema.Union',
          types: [
            {
              expect: {
                type: 'Schema.String'
              },
              type: 'Schema.Mustache'
            },
            {
              type: 'Schema.String'
            }
          ]
        },
        {
          name: 'value',
          type: 'Schema.Any'
        }
      ],
      type: 'Schema.Object'
    }
  ]

  override relationTo = 'Schema.Action'
}
